<button
  pButton
  label="Add File"
  type="button"
  severity="secondary"
  icon="pi pi-plus"
  data-test-id="add-file-button"
  (click)="addFile()"
></button>

<div class="upload-btn-wrapper">
  <input
    #inputFile
    type="file"
    name="myfile"
    data-test-id="file-input"
    [multiple]="multiple"
    [accept]="accept"
    (change)="onFileSelect($event)"
  />
</div>
